import { updateMutationAndCurrencyAction } from '../actions/UiActions';
import container from '../services/Container';

export default class MutationAndCurrencyHelper {

	/**
	 * Method is static because its used in server.js
	 *
	 * @param {object} match
	 */
	static getMutationParam(match) {
		if (match.params.mutationA === undefined) {
			return match.params.mutationB;
		}
		return match.params.mutationA;
	}

	/**
	 * Method is static because its used in server.js
	 *
	 * @param {object} match
	 */
	static getCurrencyParam(match) {
		return match.params.currency;
	}

	/**
	 * Update Mutation And Currency If Required
	 *
	 * @param {?string} currentMutationParam
	 * @param {?string} currentCurrencyParam
	 * @param {?string} updatedMutationParam
	 * @param {?string} updatedCurrencyParam
	 */
	static updateMutationAndCurrencyIfRequired(
		currentMutationParam = null,
		currentCurrencyParam = null,
		updatedMutationParam = null,
		updatedCurrencyParam = null
	) {
		const ui = container.state.ui;
		const currentMutation = currentMutationParam === null ? ui.defaultMutation.code : currentMutationParam;
		const currentCurrency = currentCurrencyParam === null ? ui.defaultCurrency.getCodeForUrl() : currentMutationParam;
		const updatedMutation = updatedMutationParam === null ? ui.defaultMutation.code : updatedMutationParam;
		const updatedCurrency = updatedCurrencyParam === null ? ui.defaultCurrency.getCodeForUrl() : updatedCurrencyParam;
		const mutationChange = updatedMutation !== currentMutation ? updatedMutation : null;
		const currencyChange = updatedCurrency !== currentCurrency ? updatedCurrency : null;

		if (mutationChange || currencyChange) {
			container.store.dispatch(updateMutationAndCurrencyAction(mutationChange, currencyChange));
		}
	}
}





// WEBPACK FOOTER //
// ./helpers/MutationAndCurrencyHelper.js